export const isBuyer = (user) => ['buyer', 'main_buyer'].includes(user?.Company?.Type);
